<div class="classify-container p-4 flex-table-page routed-flex-table-page">
  <!-- Loading Overlay for Operations -->
  <div *ngIf="deleteLoading() || statusUpdateLoading()" class="loading-overlay">
    <div class="loading-content">
      <div class="flex items-center space-x-3">
        <div
          class="loading-spinner rounded-full h-8 w-8 border-b-2 border-blue-600"
        ></div>
        <div class="loading-text">
          <span *ngIf="deleteLoading()">{{
            "goods.classify.loading.deleting_categories" | translate
          }}</span>
          <span *ngIf="statusUpdateLoading()">{{
            "goods.classify.loading.updating_status" | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="classify-content flex">
    <!-- Left Sidebar - Combined Search and Tree -->
    <div class="flex-left">
      <app-classify-sidebar
        (categorySelect)="onCategorySelect($event)"
        [clearSelection]="clearSidebarSelection()"
      ></app-classify-sidebar>
    </div>

    <!-- Right Content Area -->
    <div class="flex-right">
      <!-- Search Form -->
      <app-search-form
        [searchFormat]="searchConfig"
        (formSearch)="onSearch($event)"
        (formReset)="onReset()"
      >
        <div slot="actions" class="flex gap-2">
          <app-button
            type="success"
            [outlined]="true"
            icon="view_column"
            (emitOnClick)="onColumnConfigClick($event)"
          ></app-button>
          <app-status-filter
            [primaryButton]="primaryButton()"
            [secondaryButton]="secondaryButton()"
            (primaryButtonClick)="onAdd()"
            (secondaryButtonClick)="onBatchDelete()"
          ></app-status-filter>
        </div>
      </app-search-form>

      <!-- Data Table -->
      <div class="flex-table-section">
        <advanced-data-table
          #advancedTable
          [dataSource]="categories()"
          [defaultColumns]="defaultColumns()"
          [flexibleColumns]="flexibleColumns()"
          [loading]="loading()"
          [rows]="searchParams().size"
          [first]="searchParams().page * searchParams().size"
          [totalRecords]="totalRecords()"
          [hasCheckColumn]="canDelete()"
          [selection]="selectedCategories()"
          scrollHeight="flex"
          (selectionChange)="onSelectionChange($event)"
          (pageChange)="onPageChange($event)"
          [showInternalColumnConfigButton]="false"
          class="w-full"
        >
          <!-- Custom Template for Category Type and Attribute Count -->
          <ng-template
            #customTemplate
            let-value
            let-rowData="rowData"
            let-column="column"
          >
            @if (column && column.prop === "subFlag") {
              {{ getCategoryTypeLabel(value) }}
            } @else if (column && column.prop === "attributeList") {
              {{ getAttributeCount(value) }}
            }
          </ng-template>

          <!-- Custom Status Template -->
          <ng-template #statusTemplate let-status>
            <div class="flex items-center justify-center gap-1">
              <p-tag
                [value]="getStatusDisplayText(status) | translate"
                [severity]="getStatusSeverity(status)"
                styleClass="status-tag"
                [ngStyle]="getStatusStyle(status)"
                [pTooltip]="
                  status
                    ? ('common.table.status.active' | translate)
                    : ('common.table.status.inactive' | translate)
                "
                tooltipPosition="top"
                tooltipStyleClass="custom-tooltip"
                [showDelay]="300"
                [hideDelay]="0"
              />
            </div>
          </ng-template>

          <!-- Custom Actions Template -->
          <ng-template #actionsTemplate let-rowData>
            <div
              class="flex w-full items-center justify-center gap-2 whitespace-nowrap"
            >
              @if (canRead()) {
                <button
                  [attr.data-testid]="'category-action-view-' + rowData.id"
                  type="button"
                  class="action-link action-view cursor-pointer"
                  [disabled]="deleteLoading() || statusUpdateLoading()"
                  (click)="onView(rowData)"
                >
                  {{ "common.actions.view" | translate }}
                </button>
              }
              @if (canUpdate()) {
                <button
                  [attr.data-testid]="'category-action-edit-' + rowData.id"
                  type="button"
                  class="action-link action-edit cursor-pointer"
                  [disabled]="
                    deleteLoading() ||
                    statusUpdateLoading() ||
                    rowData.hasOpenDraft
                  "
                  (click)="onEdit(rowData)"
                >
                  {{ "common.actions.edit" | translate }}
                </button>
              }
              @if (hasOthersActions(rowData)) {
                <button
                  [attr.data-testid]="'category-action-others-' + rowData.id"
                  type="button"
                  class="action-link action-others cursor-pointer"
                  aria-haspopup="menu"
                  [disabled]="deleteLoading() || statusUpdateLoading()"
                  (click)="toggleOthersMenu($event, rowData)"
                >
                  {{ "common.actions.others" | translate }}
                </button>
              }
            </div>
          </ng-template>
        </advanced-data-table>
      </div>
    </div>
  </div>

  <p-menu
    #actionMenu
    [popup]="true"
    [model]="currentMenuModel()"
    appendTo="body"
    [baseZIndex]="2100"
    styleClass="actions-menu text-[0.75rem]"
  ></p-menu>

  <!-- Toast Messages -->
  <p-toast></p-toast>
</div>

<!-- Shared Confirmation Dialog -->
<app-confirmation-dialog
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle"
  [message]="dialogMessage"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
></app-confirmation-dialog>
